/**
 * @generated SignedSource<<cabba9f06623c5e4f1748f9d42162011>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BlockPermanentlyRestartIfFailedContentConfigForm_TreeNodeFragment$data = {
  readonly id: string;
  readonly " $fragmentType": "BlockPermanentlyRestartIfFailedContentConfigForm_TreeNodeFragment";
};
export type BlockPermanentlyRestartIfFailedContentConfigForm_TreeNodeFragment$key = {
  readonly " $data"?: BlockPermanentlyRestartIfFailedContentConfigForm_TreeNodeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"BlockPermanentlyRestartIfFailedContentConfigForm_TreeNodeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BlockPermanentlyRestartIfFailedContentConfigForm_TreeNodeFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "TreeNode",
  "abstractKey": null
};

(node as any).hash = "73be271988d4577beb3e94d5a3cfad8e";

export default node;
